module.exports = __webpack_public_path__ + "static/avatar-11e569a48ff6687f815b1fe05b3a59fb.png";